var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaitlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 2.57143H14.5714V1.71429C14.5701 1.26005 14.389 0.824799 14.0678 0.503601C13.7466 0.182404 13.3114 0.00135662 12.8571 0H6C5.54576 0.00135662 5.11051 0.182404 4.78931 0.503601C4.46812 0.824799 4.28707 1.26005 4.28571 1.71429V2.57143H1.71429C1.26005 2.57279 0.824799 2.75383 0.503601 3.07503C0.182404 3.39623 0.00135662 3.83147 0 4.28571V22.2857C0.00135662 22.74 0.182404 23.1752 0.503601 23.4964C0.824799 23.8176 1.26005 23.9986 1.71429 24H9.42857V22.2857H1.71429V4.28571H4.28571V6.85714H14.5714V4.28571H17.1429V12.8571H18.8571V4.28571C18.8558 3.83147 18.6747 3.39623 18.3535 3.07503C18.0323 2.75383 17.5971 2.57279 17.1429 2.57143ZM12.8571 5.14286H6V1.71429H12.8571V5.14286Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9795 23.625V19.125M14.9795 19.125V14.625M14.9795 19.125H19.4795M14.9795 19.125H10.4795",
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitlist);
export default __webpack_public_path__ + "static/media/Waitlist.297d8e41e4261c4473b6111ab0ca9990.svg";
export { ForwardRef as ReactComponent };